import Toast from "../Components/toast";
import WishListFrame from "../Components/Wishlist/WishListFrame";

function Wishlist() {
  return (
    <>
      <WishListFrame />
      <Toast />
    </>
  );
}
export default Wishlist;
